import React from "react";

const FooterIcons = () => {
  return (
    <div className="footer__icons">
      <a
        rel="noreferrer noopener"
        target="_blank"
        href="https://www.instagram.com/tablesagedining/"
      >
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="footer"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Desktop-HD" transform="translate(-794.000000, -551.000000)">
              <g
                id="follow-links"
                transform="translate(794.000000, 551.000000)"
              >
                <g id="instagram">
                  <circle
                    id="bg"
                    fill="#FFFFFF"
                    cx="17.82"
                    cy="17.82"
                    r="17.82"
                  ></circle>
                  <g
                    id="instagram-icon"
                    transform="translate(6.000000, 7.000000)"
                    fillRule="nonzero"
                  >
                    <path
                      d="M2.88368958,1.86665647 C5.07519832,-0.733265454 20.56109,0.586369622 21.4149042,1.86665647 C22.2687185,3.14694331 23.6542591,19.7762617 21.4149042,20.6879211 C19.1755494,21.5995805 3.94767727,21.5995805 2.88368958,20.6879211 C1.81970189,19.7762617 0.69218084,4.46657839 2.88368958,1.86665647 Z"
                      id="Rectangle"
                      fill="#000000"
                    ></path>
                    <path
                      d="M12.2954545,1.60454545 C15.4515506,1.60454545 15.8258691,1.61636604 17.0729407,1.67349886 C20.2763191,1.81928607 21.7726081,3.33921621 21.9183953,6.51895341 C21.9755281,7.76504001 21.9863636,8.13935852 21.9863636,11.2954545 C21.9863636,14.4525356 21.9745431,14.8258691 21.9183953,16.0719557 C21.771623,19.2487377 20.2792742,20.771623 17.0729407,20.9174102 C15.8258691,20.9745431 15.4535207,20.9863636 12.2954545,20.9863636 C9.13935852,20.9863636 8.76504001,20.9745431 7.51895341,20.9174102 C4.30769465,20.770638 2.81928607,19.2438125 2.67349886,16.0709706 C2.61636604,14.824884 2.60454545,14.4515506 2.60454545,11.2944695 C2.60454545,8.13837347 2.61735109,7.76504001 2.67349886,6.51796836 C2.82027112,3.33921621 4.3126199,1.81830102 7.51895341,1.67251381 C8.76602506,1.61636604 9.13935852,1.60454545 12.2954545,1.60454545 L12.2954545,1.60454545 Z M12,0 C8.741,0 8.333,0.0128333333 7.053,0.066 C2.695,0.249333333 0.273,2.46583333 0.073,6.46433333 C0.014,7.63858333 0,8.01258333 0,11 C0,13.9874167 0.014,14.3623333 0.072,15.5356667 C0.272,19.5305 2.69,21.7506667 7.052,21.934 C8.333,21.9871667 8.741,22 12,22 C15.259,22 15.668,21.9871667 16.948,21.934 C21.302,21.7506667 23.73,19.5341667 23.927,15.5356667 C23.986,14.3623333 24,13.9874167 24,11 C24,8.01258333 23.986,7.63858333 23.928,6.46525 C23.732,2.47408333 21.311,0.25025 16.949,0.0669166667 C15.668,0.0128333333 15.259,0 12,0 Z M12.3363636,5.52818182 C9.12223511,5.52818182 6.51636364,8.13384186 6.51636364,11.3477096 C6.51636364,14.5615774 9.12223511,17.1681818 12.3363636,17.1681818 C15.5504922,17.1681818 18.1563636,14.5625218 18.1563636,11.3477096 C18.1563636,8.13384186 15.5504922,5.52818182 12.3363636,5.52818182 Z M12.3513636,15.2927273 C10.1747456,15.2927273 8.41,13.528967 8.41,11.3513636 C8.41,9.17474557 10.1747456,7.41 12.3513636,7.41 C14.5279817,7.41 16.2927273,9.17474557 16.2927273,11.3513636 C16.2927273,13.528967 14.5279817,15.2927273 12.3513636,15.2927273 Z M18.023172,3.31818182 C17.3073248,3.31818182 16.7272727,3.8982339 16.7272727,4.61318182 C16.7272727,5.32812973 17.3073248,5.90818182 18.023172,5.90818182 C18.7381199,5.90818182 19.3172727,5.32812973 19.3172727,4.61318182 C19.3172727,3.8982339 18.7381199,3.31818182 18.023172,3.31818182 Z"
                      id="Shape"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.facebook.com/TableSageDining"
      >
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="footer"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Desktop-HD" transform="translate(-840.000000, -551.000000)">
              <g
                id="follow-links"
                transform="translate(794.000000, 551.000000)"
              >
                <g id="facebook-" transform="translate(46.000000, 0.000000)">
                  <circle
                    id="bg"
                    fill="#FFFFFF"
                    cx="17.82"
                    cy="17.82"
                    r="17.82"
                  ></circle>
                  <path
                    d="M23.41975,14.9300619 L19.93,14.9300619 L19.93,12.9500619 C19.93,11.9283819 20.01316,11.2848819 21.47737,11.2848819 L23.32669,11.2848819 L23.32669,8.13668187 C22.42678,8.04362187 21.52192,7.99808187 20.61607,8 C17.9302,8 15.97,9.64049187 15.97,12.6520719 L15.97,14.9300619 L13,14.9300619 L13,18.8900619 L15.97,18.8890719 L15.97,27.8000619 L19.93,27.8000619 L19.93,18.8870919 L22.96534,18.8861019 L23.41975,14.9300619 Z"
                    id="Path"
                    fill="#000000"
                    fillRule="nonzero"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://twitter.com/tablesagedining"
      >
        <svg
          width="36px"
          height="36px"
          viewBox="0 0 36 36"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Artboard"
              transform="translate(-81.000000, -46.000000)"
              fillRule="nonzero"
            >
              <g id="x-icon-copy" transform="translate(81.000000, 46.000000)">
                <circle
                  id="bg"
                  fill="#FFFFFF"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <g
                  id="Group"
                  transform="translate(8.500000, 9.500000)"
                  fill="#000000"
                >
                  <path
                    d="M15.291,0 L18.2682,0 L11.7639,7.434 L19.4157,17.55 L13.4244,17.55 L8.7318,11.4147 L3.3624,17.55 L0.3834,17.55 L7.3404,9.5985 L-8.8817842e-15,0 L6.1434,0 L10.3851,5.6079 L15.291,0 Z M14.2461,15.768 L15.8958,15.768 L5.247,1.6884 L3.4767,1.6884 L14.2461,15.768 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.linkedin.com/company/table-sage/"
      >
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="footer"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Desktop-HD" transform="translate(-932.000000, -551.000000)">
              <g
                id="follow-links"
                transform="translate(794.000000, 551.000000)"
              >
                <g id="linked-in" transform="translate(138.000000, 0.000000)">
                  <circle
                    id="bg"
                    fill="#FFFFFF"
                    cx="17.82"
                    cy="17.82"
                    r="17.82"
                  ></circle>
                  <g
                    id="linked-in-icon"
                    transform="translate(10.000000, 9.000000)"
                    fill="#000000"
                    fillRule="nonzero"
                  >
                    <path
                      d="M4,15.65 L1.15,15.65 L1.15,5.2 L4,5.2 L4,15.65 Z M2.575,3.9954 C1.6573,3.9954 0.912500004,3.2449 0.912500004,2.3196 C0.912500004,1.3943 1.6573,0.6438 2.575,0.6438 C3.4927,0.6438 4.2375,1.3943 4.2375,2.3196 C4.2375,3.2449 3.49365,3.9954 2.575,3.9954 Z M15.4,15.65 L12.55,15.65 L12.55,10.3262 C12.55,7.1266 8.75000004,7.36885 8.75000004,10.3262 L8.75000004,15.65 L5.9,15.65 L5.9,5.2 L8.75000004,5.2 L8.75000004,6.87675 C10.0762,4.42005 15.4,4.2386 15.4,9.22895 L15.4,15.65 Z"
                      id="Shape"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      {/* <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://medium.com/conscious-dining-by-table-sage"
      >
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="footer"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Desktop-HD" transform="translate(-978.000000, -551.000000)">
              <g
                id="follow-links"
                transform="translate(794.000000, 551.000000)"
              >
                <g id="medium" transform="translate(184.000000, 0.000000)">
                  <circle
                    id="bg"
                    fill="#FFFFFF"
                    cx="17.82"
                    cy="17.82"
                    r="17.82"
                  ></circle>
                  <g
                    id="medium-icon"
                    transform="translate(8.000000, 10.000000)"
                    fill="#231F20"
                  >
                    <path
                      d="M2.0344,2.4824 L0.2424,0.3224 L0.2424,-4.4408921e-16 L5.8088,-4.4408921e-16 L10.1112,9.436 L13.8936,-4.4408921e-16 L19.2,-4.4408921e-16 L19.2,0.3224 L17.6672,1.792 C17.5352,1.8928 17.4696,2.0584 17.4968,2.2224 L17.4968,13.0208 C17.4696,13.184 17.5352,13.3496 17.6672,13.4504 L19.164,14.92 L19.164,15.2424 L11.6344,15.2424 L11.6344,14.92 L13.1856,13.4144 C13.3376,13.2624 13.3376,13.2176 13.3376,12.9848 L13.3376,4.2568 L9.0264,15.2072 L8.444,15.2072 L3.424,4.2568 L3.424,11.596 C3.3824,11.904 3.4848,12.2152 3.7016,12.4376 L5.7184,14.884 L5.7184,15.2072 L-6.21724894e-15,15.2072 L-6.21724894e-15,14.884 L2.0168,12.4376 C2.2328,12.2144 2.3288,11.9016 2.2768,11.596 L2.2768,3.1096 C2.3008,2.8736 2.2104,2.6408 2.0344,2.4824 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a> */}
    </div>
  );
};

export default FooterIcons;
